// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPlusCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11 11V8h2v3h3v2h-3v3h-2v-3H8v-2z" />,
    <path
      fillRule="evenodd"
      d="M18.364 18.364A9 9 0 105.636 5.636a9 9 0 0012.728 12.728M16.95 16.95a7 7 0 10-9.9-9.9 7 7 0 009.9 9.9"
    />
  );
export default SvgIconPlusCircle;
